<template>
  <ion-card>
    <ion-card-content>
      <p>
        Are you sure you want to reassign the owner for bridge {{ serialNumber }}? The current owner will be logged out
        and their setting deleted. The new owner will receive an invite in their email.
      </p>
      <ion-row>
        <ion-col size-md="6">
          <ion-input-vue
              v-model="emailAddress"
              type="email"
              placeholder="E-mail address for the new owner"
              :disabled="busy"
              required
          />
        </ion-col>
      </ion-row>
    </ion-card-content>
    <ion-card-footer>
      <ion-row>
        <ion-col size-md="6">
          <ion-button
              expand="full"
              @click="close"
          >
            Cancel
          </ion-button>
        </ion-col>
        <ion-col size-md="6">
          <ion-button
              expand="full"
              :disabled="busy"
              color="warning"
              @click="reassignOwner"
          >
            <ion-spinner v-if="busy" />
            Reassign
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-card-footer>
  </ion-card>
</template>

<script>
import { IonInputVue, modalController } from '@modus/ionic-vue'
import store from '../../state'

export default {
  components: {
    IonInputVue
  },
  props: {
    serialNumber: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    busy: false,
    emailAddress: '',
  }),
  methods: {
    async reassignOwner () {
      this.busy = true
      try {
        await store.dispatch('reassignOwner', {
          serialNumber: this.serialNumber,
          emailAddress: this.emailAddress
        })
        await store.dispatch('fetchBridgeSettings', { serialNumber: this.serialNumber })
      } finally {
        this.close()
      }
    },
    close(){
      return modalController.dismiss()
    }
  },
}
</script>

<style scoped>
ion-card {
  margin: 0;
}
</style>

<style>
.pin-to-version-modal .modal-wrapper {
  background: none;
}
</style>
